<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.elected.resignedDuringTerm.p1')}}
    {{news.textParams[2]}}
    {{$t('news.template.elected.resignedDuringTerm.p2')}}
    <router-link :to="{name: 'forum', params: {id: news.textParams[3]}}"
    >{{news.textParams[5]}}</router-link>
  </div>
</template>
